const Icons = {
  check: 'e900',
  checks: 'e901',
  activesessions: 'e902',
  add: 'e903',
  add_chat: 'e904',
  add_reaction: 'e905',
  addboost: 'e906',
  addmember_filled: 'e907',
  adduser: 'e908',
  admin: 'e909',
  ads: 'e90a',
  align_center: 'e90b',
  align_left: 'e90c',
  align_right: 'e90d',
  animals: 'e90e',
  animations: 'e90f',
  app_expand: 'e910',
  app_shrink: 'e911',
  archive: 'e912',
  archive_filled: 'e913',
  arrow_down: 'e914',
  arrow_next: 'e915',
  arrow_prev: 'e916',
  arrow_up_circle_fill: 'e917',
  arrowcircle: 'e918',
  arrowhead: 'e919',
  attach: 'e91a',
  attach_edit: 'e91b',
  audio_repeat: 'e91c',
  audio_repeat_single: 'e91d',
  author_hidden: 'e91e',
  auto_delete_circle_1: 'e91f',
  auto_delete_circle_2: 'e920',
  auto_delete_circle_3: 'e921',
  auto_delete_circle_4: 'e922',
  auto_delete_circle_5: 'e923',
  auto_delete_circle_6: 'e924',
  auto_delete_circle_clock: 'e925',
  auto_delete_circle_days: 'e926',
  auto_delete_circle_empty: 'e927',
  auto_delete_circle_months: 'e928',
  auto_delete_circle_off: 'e929',
  auto_delete_circle_weeks: 'e92a',
  auto_delete_circle_years: 'e92b',
  avatarnext: 'e92c',
  avatarprevious: 'e92d',
  aversion: 'e92e',
  back: 'e92f',
  backward_5: 'e930',
  binfilled: 'e931',
  bold: 'e932',
  bomb: 'e933',
  boost: 'e934',
  boostcircle: 'e935',
  boosts: 'e936',
  bot_filled: 'e937',
  botcom: 'e938',
  bots: 'e939',
  brightness: 'e93a',
  brush: 'e93b',
  bubblereply: 'e93c',
  bug: 'e93d',
  calendar: 'e93e',
  calendarfilter: 'e93f',
  camera: 'e940',
  cameraadd: 'e941',
  captiondown: 'e942',
  captionup: 'e943',
  car: 'e944',
  card: 'e945',
  card_outline: 'e946',
  cash_circle: 'e947',
  channel: 'e948',
  channel_filled: 'e949',
  channelviews: 'e94a',
  chatspinned: 'e94b',
  chatsplaceholder: 'e94c',
  check1: 'e94d',
  checkbox: 'e94e',
  checkboxblock: 'e94f',
  checkboxempty: 'e950',
  checkboxon: 'e951',
  checklist_add: 'e952',
  checklist_done: 'e953',
  checklist_undone: 'e954',
  checkretract: 'e955',
  checkround: 'e956',
  checkround_filled: 'e957',
  clipboard: 'e958',
  clock: 'e959',
  close: 'e95a',
  clouddownload: 'e95b',
  collapse: 'e95c',
  colorize: 'e95d',
  comments: 'e95e',
  commentssticker: 'e95f',
  contrast: 'e960',
  copy: 'e961',
  crop: 'e962',
  cross: 'e963',
  crossgif: 'e964',
  crossround: 'e965',
  crossround_filled: 'e966',
  crossstar: 'e967',
  crown: 'e968',
  crown_outline: 'e969',
  crownalt: 'e96a',
  crownoff: 'e96b',
  crownoff_outline: 'e96c',
  darkmode: 'e96d',
  darkmode_filled: 'e96e',
  data: 'e96f',
  delete: 'e970',
  delete_filled: 'e971',
  deletedaccount: 'e972',
  deleteleft: 'e973',
  deleteuser: 'e974',
  devices: 'e975',
  document: 'e976',
  dollar_circle: 'e977',
  dollar_circle_x: 'e978',
  down: 'e979',
  down_crossed: 'e97a',
  down_up: 'e97b',
  download: 'e97c',
  dragfiles: 'e97d',
  dragmedia: 'e97e',
  eats: 'e97f',
  edit: 'e980',
  email: 'e981',
  endcall_filled: 'e982',
  enhance: 'e983',
  enter: 'e984',
  equalizer: 'e985',
  expand: 'e986',
  eye: 'e987',
  eye1: 'e988',
  eye2: 'e989',
  eyecross_outline: 'e98a',
  faceid: 'e98b',
  factcheck: 'e98c',
  fade: 'e98d',
  fast_forward: 'e98e',
  fast_rewind: 'e98f',
  favourites: 'e990',
  filter: 'e991',
  fire: 'e992',
  flag: 'e993',
  flip: 'e994',
  flip_image_horizontal: 'e995',
  folder: 'e996',
  fontframe: 'e997',
  fontframe_bg: 'e998',
  fontframe_outline: 'e999',
  fontsize: 'e99a',
  forward: 'e99b',
  forward_25: 'e99c',
  forward_filled: 'e99d',
  free_transform: 'e99e',
  fullscreen: 'e99f',
  gc_microphone: 'e9a0',
  gc_microphoneoff: 'e9a1',
  gem: 'e9a2',
  gem_exchange: 'e9a3',
  gem_transfer: 'e9a4',
  gem_transfer_outline: 'e9a5',
  geometric_digit_0: 'e9a6',
  geometric_digit_1: 'e9a7',
  geometric_digit_2: 'e9a8',
  geometric_digit_3: 'e9a9',
  geometric_digit_4: 'e9aa',
  geometric_digit_5: 'e9ab',
  geometric_digit_6: 'e9ac',
  geometric_digit_7: 'e9ad',
  geometric_digit_8: 'e9ae',
  geometric_digit_9: 'e9af',
  geometric_dot: 'e9b0',
  geometric_letter_x: 'e9b1',
  gifs: 'e9b2',
  gift: 'e9b3',
  gift_premium: 'e9b4',
  grain: 'e9b5',
  group: 'e9b6',
  group_filled: 'e9b7',
  group_star: 'e9b8',
  groupmedia: 'e9b9',
  groupmediaoff: 'e9ba',
  hand: 'e9bb',
  help: 'e9bc',
  hide: 'e9bd',
  highlights: 'e9be',
  hourglass: 'e9bf',
  image: 'e9c0',
  image_original: 'e9c1',
  info: 'e9c2',
  info2: 'e9c3',
  italic: 'e9c4',
  key: 'e9c5',
  keyboard: 'e9c6',
  lamp: 'e9c7',
  language: 'e9c8',
  largepause: 'e9c9',
  largeplay: 'e9ca',
  left: 'e9cb',
  limit_chat: 'e9cc',
  limit_chats: 'e9cd',
  limit_file: 'e9ce',
  limit_folders: 'e9cf',
  limit_link: 'e9d0',
  limit_pin: 'e9d1',
  link: 'e9d2',
  link_paid: 'e9d3',
  list: 'e9d4',
  listscreenshare: 'e9d5',
  livelocation: 'e9d6',
  livestream: 'e9d7',
  location: 'e9d8',
  lock: 'e9d9',
  lockoff: 'e9da',
  loginlogodesktop: 'e9db',
  loginlogomobile: 'e9dc',
  logo: 'e9dd',
  logout: 'e9de',
  mac_command_key: 'e9df',
  mediaspeed_empty: 'e9e0',
  mediaspoiler: 'e9e1',
  mediaspoileroff: 'e9e2',
  mention: 'e9e3',
  menu: 'e9e4',
  menu_feature_cover: 'e9e5',
  menu_feature_unique: 'e9e6',
  menu_verification: 'e9e7',
  message: 'e9e8',
  message_jump: 'e9e9',
  message_quote: 'e9ea',
  messageunread: 'e9eb',
  microphone: 'e9ec',
  microphone_crossed: 'e9ed',
  microphone_crossed_filled: 'e9ee',
  microphone_filled: 'e9ef',
  minus: 'e9f0',
  monospace: 'e9f1',
  more: 'e9f2',
  movetochats: 'e9f3',
  movetomenu: 'e9f4',
  multistories: 'e9f5',
  music: 'e9f6',
  mute: 'e9f7',
  muted: 'e9f8',
  mynotes: 'e9f9',
  newchannel: 'e9fa',
  newchannel_filled: 'e9fb',
  newchat_filled: 'e9fc',
  newgroup: 'e9fd',
  newgroup_filled: 'e9fe',
  newprivate: 'e9ff',
  newprivate_filled: 'ea00',
  newtab: 'ea01',
  next: 'ea02',
  nochannel: 'ea03',
  noncontacts: 'ea04',
  nosound: 'ea05',
  note: 'ea06',
  okay: 'ea07',
  online: 'ea08',
  passwordoff: 'ea09',
  pause: 'ea0a',
  permissions: 'ea0b',
  person: 'ea0c',
  phone: 'ea0d',
  phone_filled: 'ea0e',
  pin: 'ea0f',
  pin2: 'ea10',
  pinlist: 'ea11',
  pinned_filled: 'ea12',
  pinnedchat: 'ea13',
  pinnedchat_filled: 'ea14',
  pip: 'ea15',
  play: 'ea16',
  playback_05: 'ea17',
  playback_15: 'ea18',
  playback_1x: 'ea19',
  playback_2x: 'ea1a',
  plus: 'ea1b',
  plusround: 'ea1c',
  poll: 'ea1d',
  premium_addone: 'ea1e',
  premium_avatars: 'ea1f',
  premium_badge: 'ea20',
  premium_colors: 'ea21',
  premium_double: 'ea22',
  premium_emoji: 'ea23',
  premium_filesize: 'ea24',
  premium_lastseen: 'ea25',
  premium_limits: 'ea26',
  premium_lock: 'ea27',
  premium_management: 'ea28',
  premium_noads: 'ea29',
  premium_privacy: 'ea2a',
  premium_reactions: 'ea2b',
  premium_restrict: 'ea2c',
  premium_speed: 'ea2d',
  premium_status: 'ea2e',
  premium_stickers: 'ea2f',
  premium_tags: 'ea30',
  premium_transcription: 'ea31',
  premium_translate: 'ea32',
  premium_unlock: 'ea33',
  premium_wallpaper: 'ea34',
  previous: 'ea35',
  promote: 'ea36',
  quote: 'ea37',
  quote_outline: 'ea38',
  radiooff: 'ea39',
  radioon: 'ea3a',
  reactions: 'ea3b',
  reactions_filled: 'ea3c',
  readchats: 'ea3d',
  recent: 'ea3e',
  redo: 'ea3f',
  reload_star: 'ea40',
  replace: 'ea41',
  reply: 'ea42',
  reply_filled: 'ea43',
  restrict: 'ea44',
  revenue: 'ea45',
  rightpanel: 'ea46',
  rotate: 'ea47',
  rotate_left: 'ea48',
  rotate_right: 'ea49',
  round_chats_filled: 'ea4a',
  saturation: 'ea4b',
  saved: 'ea4c',
  savedmessages: 'ea4d',
  schedule: 'ea4e',
  scheduled: 'ea4f',
  screen_crossed: 'ea50',
  search: 'ea51',
  select: 'ea52',
  send: 'ea53',
  send2: 'ea54',
  sending: 'ea55',
  sendingerror: 'ea56',
  settings: 'ea57',
  settings_clipped_corner: 'ea58',
  settings_filled: 'ea59',
  shadows: 'ea5a',
  sharescreen_filled: 'ea5b',
  sharingoff: 'ea5c',
  sharingoff_filled: 'ea5d',
  sharingon: 'ea5e',
  sharpen: 'ea5f',
  shipping: 'ea60',
  shuffle: 'ea61',
  smallscreen: 'ea62',
  smile: 'ea63',
  sort_date: 'ea64',
  sort_num: 'ea65',
  sort_price: 'ea66',
  speaker: 'ea67',
  speakerfilled: 'ea68',
  speakeroff: 'ea69',
  speakerofffilled: 'ea6a',
  spoiler: 'ea6b',
  sport: 'ea6c',
  star: 'ea6d',
  star_filled: 'ea6e',
  statistics: 'ea6f',
  stickers: 'ea70',
  stickers_face: 'ea71',
  stop: 'ea72',
  stories: 'ea73',
  story: 'ea74',
  storyreply: 'ea75',
  storyrepost: 'ea76',
  strikethrough: 'ea77',
  suggested: 'ea78',
  tag: 'ea79',
  tag_add: 'ea7a',
  tag_alt: 'ea7b',
  tag_alt_crossed: 'ea7c',
  tag_alt_outline: 'ea7d',
  tag_crossed: 'ea7e',
  tag_filter: 'ea7f',
  tag_name: 'ea80',
  text: 'ea81',
  textedit: 'ea82',
  time_lock: 'ea83',
  timer: 'ea84',
  tip: 'ea85',
  ton: 'ea86',
  tools: 'ea87',
  topics: 'ea88',
  trade: 'ea89',
  transcribe: 'ea8a',
  unarchive: 'ea8b',
  unclaimed: 'ea8c',
  underline: 'ea8d',
  undo: 'ea8e',
  unmute: 'ea8f',
  unpack: 'ea90',
  unpin: 'ea91',
  unread: 'ea92',
  up: 'ea93',
  up_down: 'ea94',
  user: 'ea95',
  username: 'ea96',
  videocamera: 'ea97',
  videocamera_crossed_filled: 'ea98',
  videocamera_filled: 'ea99',
  videochat: 'ea9a',
  vignette: 'ea9b',
  volume_down: 'ea9c',
  volume_mute: 'ea9d',
  volume_off: 'ea9e',
  volume_up: 'ea9f',
  warmth: 'eaa0',
  warning: 'eaa1',
  webview: 'eaa2',
  win_key: 'eaa3',
  zoomin: 'eaa4',
  zoomout: 'eaa5'
};

export default Icons;
